import { memo } from 'react';
import { useRelatedVideosList } from './useRelatedVideosList';
import { RelatedVideosListProps } from './types';
import VideoCardSide from '../VideoCardSide';
import LoadingIndicator from '../LoadingIndicator';
import styles from './RelatedVideosList.module.css';

/**
 * 関連動画リストコンポーネント
 * 現在視聴中の動画に関連する動画一覧を表示
 *
 * @param video - 現在表示中の動画データ
 */
const RelatedVideosList = ({ video }: RelatedVideosListProps) => {
  // カスタムフックから関連動画と読み込み状態を取得
  const { relatedVideos, loading } = useRelatedVideosList({ video });

  return (
    <div className={styles['related-videos-list-container']}>
      {/* ローディング中表示 */}
      {loading && (
        <LoadingIndicator
          align="left"
          className={styles['related-videos-list-loading']}
        />
      )}

      {/* ローディングが終わったら配列を描画 */}
      {!loading && (
        <>
          {relatedVideos.length > 0 ? (
            <div className={styles['related-videos-list']}>
              {relatedVideos.map((relatedVideo) => (
                <VideoCardSide 
                  key={relatedVideo.id} 
                  video={relatedVideo} 
                  hideVisibilityToggle={true} 
                />
              ))}
            </div>
          ) : (
            <p>関連動画がありません。</p>
          )}
        </>
      )}
    </div>
  );
};

// videoオブジェクトが変更されたときのみ再レンダリングするようにメモ化
export default memo(RelatedVideosList, (prevProps, nextProps) => {
  // videoのIDが同じ場合は再レンダリングしない
  // 厳密な等価性ではなく、必要な部分（id）のみを比較
  return prevProps.video?.id === nextProps.video?.id;
}); 
